export const getSmscList = (builder) => ({
    getSmscList: builder.mutation({
      query: () => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/system_monitoring_smsc',
          method: 'GET',
          params: { },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  